import React from "react";
import PropTypes from "kf-proptypes/widgets";
import { Timeline as AntTimeline } from "antd";

import "antd/es/timeline/style/css";

import styles from "./timeline.css";

const STATUS_COLORS = [
  "blue",
  "green",
  "magenta",
  "yellow",
  "orange",
  "purple"
];
const COLOR_COUNT = STATUS_COLORS.length;

/**
 * Display the timeline flow.
 */

export function Timeline({
  values = [],
  highlightFirstNode,
  itemRenderer,
  className
}) {
  return (
    <AntTimeline className={`${styles.timeline} ${className}`}>
      {values?.map((value, index) => (
        <AntTimeline.Item
          key={index}
          dot={
            value.customIcon ? (
              value.customIcon
            ) : (
              <div
                className={`${
                  highlightFirstNode && index === 0 ? styles.highlight : ""
                }`}
              >
                <div
                  className={`${styles[STATUS_COLORS[index % COLOR_COUNT]]} ${
                    styles.dot
                  }`}
                />
              </div>
            )
          }
        >
          {itemRenderer(value)}
        </AntTimeline.Item>
      ))}
    </AntTimeline>
  );
}

Timeline.propTypes = {
  /**
   * value to be display as timeline
   */
  values: PropTypes.arrayOf(PropTypes.shape({ customIcon: PropTypes.node })),
  /**
   * auto highlight first node in timline
   */
  highlightFirstNode: PropTypes.bool,
  /**
   * function will return what should render
   */
  itemRenderer: PropTypes.func,
  /**
   * To override css properties of the timeline
   */
  className: PropTypes.string
};
